var _g;
const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgAdmin = _ref => {
  let {
      svgRef,
      title
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_39833",
    "data-name": "Group 39833",
    transform: "translate(-243 -89.001)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    width: 18,
    height: 18,
    transform: "translate(243 89.001)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64122",
    "data-name": "Path 64122",
    d: "M276.539,263.875c1.914-1.306,5.134-4.114,5.2-8.254.021-.471.018-2.48.015-4.252v-.144c0-.748,0-1.342,0-1.765a.5.5,0,0,0-.367-.477l-2.828-.751c-1.4-.371-2.818-.749-4.113-1.1l-.007,0-.005-.006c-.065-.077-.33-.02-2.034.449l-.379.1-.084.023,0,0-.082.022-4.742,1.261a.5.5,0,0,0-.369.482c.036,1.141.015,2.192,0,3.12-.067,3.433-.116,5.913,2.315,8.7a14.853,14.853,0,0,0,4.99,3.766.5.5,0,0,0,.417,0A15.014,15.014,0,0,0,276.539,263.875Zm-7.179-3.823-.023.036-.02-.039a7.694,7.694,0,0,1-1.58-4.493c-.01-.326-.014-3.59-.014-5.694v-.019l.019-.005,6.5-1.729.007,0c1.058.283,2.189.583,3.32.884l3.189.847v.019c0,1.73.008,5.136-.006,5.638a7.824,7.824,0,0,1-1.575,4.533l-.019.027-.02-.026a6.511,6.511,0,0,0-2.785-2.193l-.046-.016.041-.028a3.722,3.722,0,1,0-4.206,0l.041.027-.045.017A5.814,5.814,0,0,0,269.36,260.052Zm4.882-2.593a2.751,2.751,0,0,1-2.748-2.745,2.748,2.748,0,0,1,5.5,0A2.752,2.752,0,0,1,274.242,257.459Zm0,6.6-.011-.005a13.684,13.684,0,0,1-4.215-3.159l-.012-.014.009-.015a4.77,4.77,0,0,1,4.221-2.4h.005a4.779,4.779,0,0,1,4.229,2.4l.009.015-.012.014a13.018,13.018,0,0,1-2.483,2.16l-.066.047a14.428,14.428,0,0,1-1.663.954Z",
    transform: "translate(-22.209 -158.1)",
    fill: "#95A1B2"
  }))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgAdmin, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/admin.9af25acf.svg";
export { ForwardRef as ReactComponent };